import {
    CustomCategoryPropsModel,
    CustomGetCategoriesApiParameter,
    getCustomCategoriesProps,
} from "@hardware/Services/CustomCategoryService";
import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

type Parameter = CustomGetCategoriesApiParameter & HasOnSuccess;

type CustomCategoryPropsModelResult = {
    categoryShowImageOnPLP: boolean;
    gridview: boolean;
    productListGridAttributeColumns: string;
    contentTop: string;
};

type Props = {
    apiResult: CustomCategoryPropsModelResult;
    apiParameter: CustomGetCategoriesApiParameter;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, ...parameter } = props.parameter;
    props.apiParameter = parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCustomCategoriesProps(props.apiParameter);
    } catch (error) {
        if (error?.status === 404) {
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadCategories: HandlerType = props => {
    props.dispatch({
        type: "Custom/CategoryProps/GetCategoryPropertiesCompleted",
        categoryProperties: props.apiResult,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadCategories];

const loadCustomCategoryProps = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        categoryId: "",
    },
    "LoadCategories",
);
export default loadCustomCategoryProps;
